import {FORM_TABLE_TYPE} from '../../form-table-types';
import FormTableMpsTextarea from "./FormTableMpsTextarea";
import FormTableMpsText from "./FormTableMpsText";

export default {
    [FORM_TABLE_TYPE.TEXT]: FormTableMpsText,
    [FORM_TABLE_TYPE.TEXTAREA]: FormTableMpsTextarea,
}